import { combineReducers } from "redux";
import fullPageLoaderReducer from "../features/FullPageLoader/FullPageLoaderSlice";
import loginSliceReducer from "../features/login/LoginSlice";

export default combineReducers({
  loginSlice: loginSliceReducer,
  fullPageLoaderSlice: fullPageLoaderReducer,
});
